import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { SETTING } from '../../routes/routeConstant'
import { AppUseSelector } from '../../redux/hooks'
import { updateAutoMasteryUpdates } from '../../redux/actions/wordsAction'

const WordsHeader: React.FC = () => {
  const { t } = useTranslation('words')
  const navigate = useNavigate()
  const { auto_mastery_updates } = AppUseSelector(({ words }) => words)
  const [busy, setBusy] = useState(false)

  const handleToggle = async () => {
    if (busy) return
    setBusy(true)
    try {
      await updateAutoMasteryUpdates(!auto_mastery_updates)
    } catch {
      // silent — Redux state stays in sync because the action only commits on success
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className='words-header'>
      <div className='words-header-text'>
        <h2>{t('header.title')}</h2>
        <p>{t('header.intro')}</p>
      </div>
      <div className='words-header-toggle'>
        <span className='words-header-toggle-label'>
          {auto_mastery_updates ? t('header.autoMasteryOn') : t('header.autoMasteryOff')}
        </span>
        <label className='toggle-switch'>
          <input type='checkbox' checked={auto_mastery_updates} onChange={handleToggle} disabled={busy} aria-label={t('header.autoMasteryToggle')} />
          <span className='toggle-slider' />
        </label>
        <a onClick={() => navigate(`${SETTING}#words`)}>{t('header.learnMore')}</a>
      </div>
    </div>
  )
}

export default WordsHeader
